<template>
  <article class="event-services-order">
    <h3 class="event-services-order__header">
      {{ $t("event.servicesOrder.title") }}
      <icon name="pie-chart" class="event-services-order__header-icon" />
    </h3>
    <Notification
      class="event-services-order-notification"
      :warning="
        diffInSeconds(event.exhibition.additional_order_deadline) <=
          60 * 60 * 24 * 10
      "
      v-if="isOrderingAvailable"
      modify="_flex"
    >
      {{
        $t("event.servicesOrder.untilDeadline", {
          date: additionalOrderDeadline.format("DD MMMM YYYY")
        })
      }}
    </Notification>
    <Notification
      class="event-services-order-notification"
      v-if="!isOrderingAvailable"
      v-html="$t('services.popularServices.popularServiceEnd')"
    >
    </Notification>
    <div class="event-services-order__content">
      <div class="event-services-order_box">
        <span>
          {{ $t("event.servicesOrder.servicesOrders") }}
        </span>
        <span>
          <span class="count">{{ ordersCount }}</span>
        </span>
        <div style="position: relative;">
          <router-link
            class="event-services-order__table-icon"
            :to="{ name: 'orders', params: { id: event.id } }"
            style="display: flex"
          >
            <Tooltip :label="$t('services.orders.viewOrders')">
              <icon
                v-if="event.unread_additional_orders_messages_count"
                name="chat"
              />
              <icon class="look" v-else name="look" />
            </Tooltip>
          </router-link>
          <span
            v-if="event.unread_additional_orders_messages_count"
            class="count__value"
          >
            {{ event.unread_additional_orders_messages_count }}
          </span>
        </div>
      </div>

      <div class="event-services-order__actions">
        <PrimaryButton
          @click="$router.push({ name: 'cart', params: { id: eventId } })"
          class="event-services-order__cart-btn"
        >
          <CartCountComponent />
        </PrimaryButton>
        <PrimaryButton
          @click="$router.push({ name: 'categories', params: { id: eventId } })"
          :disabled="!isOrderingAvailable"
        >
          <icon name="catalog-menu" />
          {{ $t("event.servicesOrder.servicesCatalogBtn") }}
        </PrimaryButton>
      </div>
    </div>
  </article>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import CartCountComponent from "@/components/Custom/CartCountComponent.vue";
import diffInSeconds from "@/helpers/diffInSeconds";
import { i18n } from "@v2/shared/config";
import { PrimaryButton, Tooltip, Notification } from "@v2/shared/ui/components";

moment.locale(i18n.locale);

export default {
  name: "EventServicesOrder",
  props: {
    eventId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState("event", ["event"]),

    additionalOrderDeadline() {
      return moment(this.event.exhibition.additional_order_deadline);
    },
    isOrderingAvailable() {
      return this.event.exhibition.is_allowed_create_additional_order;
    },
    ordersCount() {
      return this.event.additional_orders_count || 0;
    }
  },
  methods: {
    diffInSeconds
  },
  components: {
    PrimaryButton,
    Notification,
    CartCountComponent,
    Tooltip
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";
.notification__main-icon {
  width: 30px;
  height: 27px;
  min-width: 16px;
  margin-right: 8px;
}
.event-services-order {
  width: 460px;
  min-height: 302px;
  @media (max-width: 1000px) {
    width: 350px;
  }

  margin-top: 20px;

  box-sizing: border-box;

  @media (max-width: 740px) {
    margin-top: 15px;
    min-height: 240px;
    &.services {
      width: 100%;
    }
  }
  &-notification {
    & a {
      color: inherit;
    }
  }
  &_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px 0;
    & .count {
      color: #6d7179;
    }
    & .svg-icon {
      width: 20px;
      height: 20px;
      fill: #009ee3;
    }
  }
  &__description {
    font-size: 14px;
    line-height: 1.57;
    color: #6d7179;
    display: flex;
    padding: 15px 20px 10px;
  }
  &__header {
    @include h2();

    padding: 20px 30px;

    @include respond-down(md) {
      padding: 15px;
      font-size: 1rem;
    }

    border-bottom: 1px solid var(--gray-darker);

    position: relative;
    overflow: hidden;

    &-icon {
      position: absolute;
      right: -12px;
      top: 50%;
      opacity: 0.05;
      pointer-events: none;

      transform: translateY(-50%);

      width: 60px;
      height: 60px;

      @media (max-width: 1000px) {
        display: none;
      }
      @media (max-width: 740px) {
        display: block;
        right: 8px;
        width: 56px;
        height: 56px;
      }
    }
  }

  &__content {
    padding: 0 30px 30px 30px;
    @media (max-width: 740px) {
      padding: 0 20px 20px 20px;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;

    @include respond-between(sm, md) {
      display: block;
    }

    button {
      width: 100%;
    }

    button:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  &__cart-btn {
    display: flex;
    align-items: center;
  }
}
.count__value {
  position: absolute;
  right: 0;
  top: -4px;
  transform: translate(50%, -35%);
  background-color: #005197;
  color: var(--white, #fff);
  border-radius: 50%;
  min-width: 15px;
  height: 15px;
  padding: 1px;
  font-size: 7px;
  font-weight: 500;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  box-sizing: content-box;
}
</style>
